import { ST_ATTRIBUTION_AFF_SUB1_QUERY_PARAMS, ST_ATTRIBUTION_PARAM_MAP } from '../constants/stAttributionParams';
import type { TStAttributionParams } from '../types/stAttributionParams';

const getAffSub1FromUrl = (url: URL) => {
  for (const queryParam of ST_ATTRIBUTION_AFF_SUB1_QUERY_PARAMS) {
    const value = url.searchParams.get(queryParam);

    if (value) {
      return value;
    }
  }

  return null;
};

export const getStAttributionParamsFromUrl = (urlValue?: string): TStAttributionParams => {
  if (!urlValue) {
    return {};
  }

  try {
    const url = new URL(urlValue);
    const affSub1 = getAffSub1FromUrl(url);

    const attribution = ST_ATTRIBUTION_PARAM_MAP.reduce<TStAttributionParams>((acc, { field, query }) => {
      const value = url.searchParams.get(query);

      if (value) {
        acc[field] = value;
      }

      return acc;
    }, {});

    if (affSub1) {
      attribution.affSub1 = affSub1;
    }

    return attribution;
  } catch {
    return {};
  }
};
